<template>
  <div>
    <h4>{{title}}</h4>
    <PolarArea 
      :chart-data="declaration"
      :height="250" />
  </div>
</template>

<script>

import PolarArea from '../../store/Graficos/PolarAreaChart'

export default {
  components: {
    PolarArea
  },
  data(){
    return {
      
    }
  },
  mounted () {
  },
  props:{
    title:{
      type: String
    },
    declaration:{
      type: Object
    }
  },
  methods: {
  }
}
</script>

